module.exports = __webpack_public_path__ + "static/media/Info.766b188a.svg";